import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "scan",
  "description": "`turbo scan` 명령어에 대한 API 레퍼런스"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "하나의 대화형 명령어로 Turborepo에 대한 더 빠른 툴링을 로컬에서 활성화합니다."
  }, {
    "heading": "",
    "content": "Turborepo에 대한 가장 빠른 설정을 활성화하기 위한 짧은 일련의 단계를 거치게 됩니다. 이러한 최적화에는 다음이 포함됩니다:"
  }, {
    "heading": "",
    "content": "Git FS Monitor: turbo는 파일 변경 검색을 위해 Git에 의존합니다. git이 변경 사항을 알려줄 때까지 기다려야 하므로 Git의 내장 파일시스템 모니터를 사용하여 이러한 알림을 더 빨리 받을 수 있습니다."
  }, {
    "heading": "",
    "content": "Turborepo Daemon: Turborepo의 데몬은 백그라운드에서 저장소를 낙관적으로 이해합니다. 태스크를 실행할 때 turbo가 필요로 할 공통 작업을 미리 수행함으로써 turbo는 태스크를 더 빠르게 실행합니다."
  }, {
    "heading": "",
    "content": "Remote Caching: Turborepo는 로컬에서 작업을 캐시할 수 있지만 모든 머신에서 캐시를 공유할 수도 있습니다. Remote Caching을 활성화하면 캐싱이 멀티플레이어가 되어 귀하, 팀원 및 CI 머신이 동일한 작업을 두 번 수행하지 않도록 보장합니다."
  }, {
    "heading": "",
    "content": "turbo 버전 확인: 우리는 항상 turbo를 더 좋게 만들기 위해 노력하고 있습니다. Turborepo의 최신 버전을 사용하고 있는지 확인하기 위해 버전을 확인하고 아직 사용하지 않는 경우 latest를 설치하도록 알려드립니다."
  }, {
    "heading": "",
    "content": "Turborepo LSP 확인:\nVSCode Extension Marketplace를 방문하여 IDE용 Turborepo LSP 확장 프로그램을 설치하세요."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "하나의 대화형 명령어로 Turborepo에 대한 더 빠른 툴링을 로컬에서 활성화합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " scan"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Turborepo에 대한 가장 빠른 설정을 활성화하기 위한 짧은 일련의 단계를 거치게 됩니다. 이러한 최적화에는 다음이 포함됩니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Git FS Monitor"
        }), ": ", _jsx(_components.code, {
          children: "turbo"
        }), "는 파일 변경 검색을 위해 Git에 의존합니다. ", _jsx(_components.code, {
          children: "git"
        }), "이 변경 사항을 알려줄 때까지 기다려야 하므로 ", _jsx(_components.a, {
          href: "https://git-scm.com/docs/git-fsmonitor--daemon",
          children: "Git의 내장 파일시스템 모니터"
        }), "를 사용하여 이러한 알림을 더 빨리 받을 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Turborepo Daemon"
        }), ": Turborepo의 데몬은 백그라운드에서 저장소를 낙관적으로 이해합니다. 태스크를 실행할 때 ", _jsx(_components.code, {
          children: "turbo"
        }), "가 필요로 할 공통 작업을 미리 수행함으로써 ", _jsx(_components.code, {
          children: "turbo"
        }), "는 태스크를 더 빠르게 실행합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Remote Caching"
        }), ": Turborepo는 로컬에서 작업을 캐시할 수 있지만 모든 머신에서 캐시를 공유할 수도 있습니다. ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching",
          children: "Remote Caching"
        }), "을 활성화하면 캐싱이 ", _jsx(_components.strong, {
          children: "멀티플레이어"
        }), "가 되어 귀하, 팀원 및 CI 머신이 동일한 작업을 두 번 수행하지 않도록 보장합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(_components.code, {
            children: "turbo"
          }), " 버전 확인"]
        }), ": 우리는 항상 ", _jsx(_components.code, {
          children: "turbo"
        }), "를 더 좋게 만들기 위해 노력하고 있습니다. Turborepo의 최신 버전을 사용하고 있는지 확인하기 위해 버전을 확인하고 아직 사용하지 않는 경우 ", _jsx(_components.code, {
          children: "latest"
        }), "를 설치하도록 알려드립니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Turborepo LSP 확인"
        }), ":\n", _jsx(_components.a, {
          href: "https://marketplace.visualstudio.com/items?itemName=Vercel.turbo-vsc",
          children: "VSCode Extension Marketplace"
        }), "를 방문하여 IDE용 Turborepo LSP 확장 프로그램을 설치하세요."]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
